import { createStore } from 'vuex'
import authStore from '../modules/auth/store'
import avaliationsStore from '../modules/avaliations/store'
import clientEmployeeStore from '../modules/client_employee/store'
import clientStore from '../modules/client/store'
import employeeStore from '../modules/employee/store'
import menuStore from '../modules/menu/store'
import serviceStore from '../modules/services/store'
import stockItemStore from '../modules/stock/modules/stock_items/store'
import clientsServicesSchedulesStore from '../modules/clients_services_schedule/store'
import clientServicesStore from '../modules/client_services/store'
import clientAddressesStore from '../modules/client_addresses/store'
import responsiblesStore from '../modules/responsibles/store'
import stockControlStore from '../modules/stock/modules/stock_control/store'
import timeCardsStore from '../modules/time_cards/store'
import registerPointStore from '../modules/register_point/store'
import employeeSubstitutionsStore from '../modules/employee_substitutions/store'
import clientComplaintsStore from '../modules/client_complaints/store'
import serviceOrderStore from '../modules/service_order/store'
import birthdaysStore from '../modules/birthdays/store'

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth: authStore,
    avaliations: avaliationsStore,
    client_complaints: clientComplaintsStore,
    client_employee: clientEmployeeStore,
    client_services: clientServicesStore,
    client_addresses: clientAddressesStore,
    clients_services_schedules: clientsServicesSchedulesStore,
    clients: clientStore,
    employees: employeeStore,
    employee_substitutions: employeeSubstitutionsStore,
    menu: menuStore,
    responsibles: responsiblesStore,
    register_point: registerPointStore,
    services: serviceStore,
    stock_control: stockControlStore,
    stock_items: stockItemStore,
    service_order: serviceOrderStore,
    time_cards: timeCardsStore,
    birthdays: birthdaysStore,
  }
})
